// ** Initial State
const initialState = {
  pageLoader: false,
  floorData: null,
  floorListWithPagination: {
  "limit": 30,
  "page": 0,
  "total_pages": null,
  "total_records": null,
  "data": null
  },
  pageLoader:true
}
const floor = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_DATA':
      return { ...state, data: null }
    case 'GET_ALL_FLOOR':
      return { ...state, floorListWithPagination: action.data, pageLoader: false }
    case 'GET_FLOOR_DATA':
      return { ...state, floorData: action.data }
    case 'PAGE_LOADER':
      return { ...state, pageLoader: action.data }
    case 'DELETE_FLOOR_DATA':
      return { ...state, pageLoader: action.data }
    default:
      return { ...state }
  }
}
export default floor
